import Select from "../../../../form/Select";
import React from "react";
import isEqual from "lodash-es/isEqual";
import {optionsTemplate} from "../../../../../utils/formatters";

export class Source extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (isEqual(props.values.id + "", (pProps || {}).id + "") && !isEqual((props.values.seller || {}).partner_id, (((pProps || {}).values.seller) || {}).partner_id)) {
            props.setFieldValue("source", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        return (hidden || []).indexOf("source") === -1 && <Select
            label={labels.source || "Honnan"}
            name="source"
            component="location"
            objectValue={true}
            labelKey="name"
            storeType="local"
            autoSelect={true}
            optionsTemplate={optionsTemplate("location")}
            filter={[{
                field: "roles.optionid",
                value: "4" // ShopSupplyStore
            }]}
            order={[{field: "name"}]}
            {...props.getProps("source")}
            value={props.getValue("source")}
            saveChanges={props.setFieldValue}
        />;
    }
}

export default Source;